import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface DataTablePrimaryCellProps {
  className?: string
  subtitle?: ReactNode
  title: ReactNode
  titleClassName?: string
}

export function DataTablePrimaryCell({
  className,
  subtitle,
  title,
  titleClassName,
}: DataTablePrimaryCellProps) {
  return (
    <div className={cn('min-w-0', className)}>
      <span className={cn('block truncate font-medium text-[var(--color-text)]', titleClassName)}>
        {title}
      </span>
      {subtitle ? (
        <span className="mt-0.5 block truncate text-xs text-[var(--color-text-muted)]">
          {subtitle}
        </span>
      ) : null}
    </div>
  )
}
